module.exports = __webpack_public_path__ + "img/dent.74b2cb7f.svg";